import register from '../util/init'
import {getOffset, toggle} from '../util/tools'
import {PHONE_MAX} from './constants'

import ScrollBalance from '../util/scrollbalance'

class initPage {
  constructor (container) {
    this.container = container
    this.windowWidth = null

    // set current sponsor expanded state
    this.sponsorList = document.querySelector('.sponsor-list.expanded').getAttribute('id')

    // init load scroll down if we have a 'fake' hash
    const urlParams = new URLSearchParams(window.location.search)
    this.profile = urlParams.get('profile')
    const profileEl = document.getElementById(this.profile)

    if (this.profile && profileEl) {
      window.setTimeout(() => {
        window.scroll({
          top: getOffset(profileEl).top - 140, // includes a slight buffer
          left: 0,
          behavior: 'smooth'
        })
      }, 1000)
    } else {
      // DISABLED fallback no param request
      // document.querySelector('.profile.expanded').getAttribute('id')
    }

    this.container.querySelectorAll('.expandable').forEach((ex) => {
      const trigger = ex.querySelector('.trigger')
      trigger.addEventListener('click', (e) => {
        e.preventDefault()
        // if it's an open profile/sponsor,
        // reset the current state
        if (ex.classList.contains('profile')) {
          // profile
          this.profile = ex.getAttribute('id')
          toggle(ex, 'expanded', this.expandProfileCallback, this)
        } else {
          // sponsor
          this.sponsorList = ex.getAttribute('id')
          toggle(ex, 'expanded', this.expandSponsorListCallback, this)
        }
      })
    })

    return {
      resize: (w, h) => {
        this.windowWidth = w
        // init balance
        this.container.querySelectorAll('.balance').forEach((balanceThis) => {
          this.balanceExpandedContent(balanceThis, this)
        })
      },
      scroll: (top, left) => {}
    }
  }
  /**
  * setups a few different states when an item has been opened/closed
  *
  * @param {bool} isExpanded
  * @param {Class} that, this(InitPage)
  */
  expandProfileCallback (isExpanded, that) {
    if (isExpanded) {
      // opening
      document.querySelector('.all-profiles').classList.add('profile-expanded')
      if (that.windowWidth > PHONE_MAX) {
        // remove expanded class from other profiles/sponsors
        document.querySelectorAll(`.profile.expanded:not([id=${that.profile}])`).forEach((el) => {
          el.classList.remove('expanded')
        })
      }
      // update url if current
      const url = document.querySelector(`#${that.profile} .trigger`).getAttribute('href')
      window.history.replaceState({ns: 'placeintime'}, null, url)
    } else {
      // closeing
      document.querySelector('.all-profiles').classList.remove('profile-expanded')
      // reset url
      const url = document.querySelector(`.all-profiles`).getAttribute('data-default-url')
      window.history.replaceState({ns: 'placeintime'}, null, url)
    }
  }
  /**
  * setups a few different states when an item has been opened/closed
  *
  * @param {bool} isExpanded
  * @param {Class} that, this(InitPage)
  */
  expandSponsorListCallback (isExpanded, that) {
    if (isExpanded) {
      const current = document.querySelector(`#${that.sponsorList}`)
      // remove expanded class from other profiles/sponsors
      document.querySelectorAll(`.sponsor-list.expanded:not([id=${that.sponsorList}])`).forEach((el) => {
        el.classList.remove('expanded')
      })
      that.balanceExpandedContent(document.querySelector('.sponsors-contributors'), that)

      const targetSelector = current.getAttribute('data-target-selector')
      document.querySelector(targetSelector).innerHTML = current.querySelector('.target').innerHTML
    }
  }
  /**
  * scrollbalance - only get's called if tablet-plus
  *
  * @param {HTMLElement} balanceThis
  * @param {Class} that, this(InitPage)
  */
  balanceExpandedContent (balanceThis, that) {
    if (that.windowWidth > PHONE_MAX) {
      const inside = balanceThis.querySelector('.inside')
      const hgroup = inside.querySelector('hgroup')
      document.querySelector('.expand-target').style.marginTop = `${hgroup.clientHeight}px`
      if (!that.scrollbalance) {
        that.scrollbalance = new ScrollBalance(balanceThis.querySelectorAll('.inside'), {})
        that.scrollbalance.bind()
      }
    } else {
      // phone
      if (that.scrollbalance) {
        that.scrollbalance.teardown()
        that.scrollbalance = null
      }
    }
  }
}
register('.about-content', initPage)



// WEBPACK FOOTER //
// ./assets/j/src/about.js